module.exports = __webpack_public_path__ + "img/logo.8018d2f.svg";